exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recording-tile i {\r\n    float: right;\r\n}\r\n\r\n.recording-tile i::before {\r\n    margin: 0px;\r\n    font-size: 20px;\r\n}\r\n\r\n.recording-tile .main {\r\n    font-size: 30px;\r\n    bottom: 30px;\r\n    position: absolute;\r\n    width: 85%;\r\n}\r\n\r\ndiv.tile-body div.number {\r\n    font-size: 15px;\r\n}\r\n\r\ndiv.tile-object p {\r\n    margin: 0px;\r\n    color: #FFFFFF;\r\n    line-height: 30px;\r\n}\r\n.observationDate {\r\n    font-size: 12px;\r\n}\r\n\r\n.date {\r\n    cursor: pointer;\r\n    width: 150px;\r\n    display: inline-block;\r\n    text-align: center;\r\n    margin: 5px;\r\n    margin-bottom: 20px;\r\n    border: 1px solid black;\r\n    border-radius: 5px !important;\r\n}\r\n\r\n.date.selected{\r\n    background: #009dc7;\r\n    color: white;\r\n    border-color: #009dc7;\r\n}\r\n.tab-pane { width:100%;}\r\n.breadcrumbs-compact {\r\n    margin-bottom: 0px;\r\n}\r\n.tiles .tile {\r\n    width: 163px !important;\r\n}\r\n.monitoring-plot-area {\r\n    min-width: 1032px;\r\n}\r\n\r\n.eCGChartdiv {\r\n    padding-top: 20px;\r\n}\r\n.eCGChartdiv img {\r\n    width: 100%;\r\n    padding-bottom: 10px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/case/details/monitoring/case-details-monitoring.component.css
// module id = 977
// module chunks = 1